export class WLMDialogResult {
  result: boolean;
  isDenied?: boolean;
  isDismissed?: boolean;
  constructor(init: Readonly<WLMDialogResult>) {
    Object.assign(this, init);
  }
}
